import { Link } from '@tanstack/react-router'
import { Building2, Store } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useWorkspaceEntitlements } from '../model/use-workspace-entitlements'
import { OrganizationPlanCode } from '@/graphql/schema'

export function WorkspacePlanBrand() {
  const { entitlements } = useWorkspaceEntitlements()
  const isPro = entitlements?.plan === OrganizationPlanCode.Pro

  return entitlements ? <WorkspacePlanBrandView isPro={isPro} /> : null
}

export function WorkspacePlanBrandView({ isPro }: { isPro: boolean }) {
  const { t } = useTranslation()
  const plan = isPro ? t('workspacePlan:pro') : t('workspacePlan:free')
  const Icon = isPro ? Building2 : Store

  return (
    <Link
      aria-label={t('workspacePlan:currentPlan', { plan })}
      className="group relative inline-flex rounded-xl outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      to="/settings/payments"
    >
      <Icon
        aria-hidden="true"
        className={`h-12 w-12 rounded-xl border border-border p-2 shadow-md transition-colors ${isPro ? 'bg-background text-primary group-hover:bg-primary/10' : 'bg-secondary text-secondary-foreground group-hover:bg-secondary/80'}`}
      />
      <span
        aria-hidden="true"
        className={`absolute bottom-0 right-0 translate-x-1/4 translate-y-1/4 rounded-full border px-1.5 py-0.5 text-[10px] font-semibold leading-none ${isPro ? 'border-primary/30 bg-primary text-primary-foreground' : 'border-border bg-muted text-muted-foreground'}`}
      >
        {plan}
      </span>
    </Link>
  )
}
